import {gsap, Observer, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-main");
		this.isScrollingTo = false;
		if (this.header) {
			this.navMain = this.header.querySelector(".nav-section");
			this.headerClass = this.header.className;
			this.toggleHeader();
			this.initNav();
			this.resize();
		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	static initNavLang(){

		const mobileLang = document.querySelector(".nav-lang");
		if(mobileLang && GlobalVariables.isMobile){
			mobileLang.addEventListener("click", (e) => {
				document.body.classList.toggle('nav-lang-open', !document.body.classList.contains('nav-lang-open'));
			});
		}

	}

	static openMobileMenu(){

		const openMobileMenu = document.querySelector(".nav-main-toggle");
		if( openMobileMenu ) {
			openMobileMenu.addEventListener("click", () => {
				document.body.classList.add("nav-main-open");
				GlobalVariables.smoother.paused(true);
			});
		}

	}

	static closeMobileMenu() {

		const closeMobileMenu = document.querySelector(".nav-main-close");
		if( closeMobileMenu ) {
			closeMobileMenu.addEventListener("click", () => {
				document.body.classList.remove("nav-main-open");
				GlobalVariables.smoother.paused(false);
			});
		}

	}

	static toggleHeader() {
		let mm = gsap.matchMedia();
		// mm.add("(min-width: 992px)", () => {
			this.observer = Observer.create({
				type: "scroll",
				tolerance: 30,
				dragMinimum: 30,
				onStop: () => {
					this.isScrollingTo = false;
					if (window.scrollY < 100) {
						this.header.classList.add("is-on-top");
						this.header.className = this.headerClass;
					} else {
						this.header.classList.remove("is-on-top");
					}
				},
				onStopDelay: 0,
				onUp: () => {
					if( ! this.isScrollingTo ) {
						this.showHeader();
					}
				},
				onDown: () => {
					if( ! this.isScrollingTo && window.scrollY > this.header.offsetHeight ) {
						this.hideHeader();
					}
				},
			});

			if (window.innerWidth > 991) {
				setTimeout(() => {
					if (window.scrollY > 100) {
						this.hideHeader();
					}
				}, 0);
			}
		// });
	}

	static hideHeader() {
		this.header.className = this.headerClass + " hide ";
	}

	static showHeader() {
		this.header.classList.remove("hide");
		if (this.header.classList.contains('header-main-full')) {
			this.removeClassByPrefix(this.header, 'section');
			this.header.classList.add('section');
			this.header.classList.add( this.header.dataset.sectionColor );
		}
	}

	static initNav() {
		this.initNavLang();
		this.openMobileMenu();
		this.closeMobileMenu();
		this.initNavAnchor();
	}
	static openSubNavBurger(element){

		element.preventDefault();
		let item = element.target.closest('.menu-item--lev1') || element.target;
		let subNav = item.querySelector('.lev2');

		if (item.classList.contains("subnav-open")) {
			item.classList.remove("subnav-open");
			gsap.to(subNav, {
				height: 0,
				duration: 0.3
			});
		} else {
			item.classList.add("subnav-open");
			gsap.to(subNav, {
				height: subNav.dataset.height,
				duration: 0.3
			});
		}

	}

	static initNavAnchor(){

		let navigation = document.querySelectorAll('.nav-section-menu li a');
		navigation.forEach( (anchor, index) => {

			let section = document.getElementById(anchor.dataset.scrollTo);

			// Scroll vers la section demandée
			anchor.addEventListener('click', (e) => {
				e.preventDefault();
				let target = section.getBoundingClientRect();
				this.isScrollingTo = true;
				gsap.to(window, {
					scrollTo: {
						y: target.top + window.scrollY - this.header.offsetHeight,
						autoKill: false
					},
					duration: 0.5,
					ease: "linear"
				});
			});

			let nextElement = ( (index+1) === navigation.length ) ? document.querySelector('.footer-main') : document.getElementById(navigation[index + 1].dataset.scrollTo);

			// Élément de menu actif
			ScrollTrigger.create({
				trigger: section,
				start: "top top+=" + this.header.offsetHeight,
				endTrigger : nextElement,
				end: "top top+=" + this.header.offsetHeight,
				toggleClass: {
					targets: anchor,
					className: 'active'
				}
			});

		});

	}

	static removeNavMainSectionClass(){

		if( !this.header.classList.contains('header-main-burger') && window.innerWidth > 991 ){
			this.removeClassByPrefix(this.navMain, 'section');
		}else{
			this.navMain.classList.add("section");
			this.navMain.classList.add(this.header.dataset.sectionColor);
		}

	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

	static resize(){

		this.removeNavMainSectionClass();
		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused( false );
		}

	}
}
